import { http } from './http';

export function searchMulti(query, page = 1, { language } = {}) {
  const params = { query, page, ...(language ? { language } : {}) };
  return http.get('/api/v1/search', { params }).then((r) => r.data);
}
